var Reflux = require('reflux');

module.exports = Reflux.createActions([
  "fetchAvailableChallenges",
  "fetchNewestChallenges",
  "fetchWaitingChallenges",
  "fetchLaterChallenges",
  "fetchCompletedChallenges",
  "laterChallenge",
  "fetchUnlockedChallenges",
  "fetchUnlockableChallenges",
  "fetchExperiences",
  "fetchChannels",
  "retrieveChallengeStatusDescription",
  "setChannelId",
  "setCurrentChannel",
  "setPageSize"
]);



// WEBPACK FOOTER //
// ./src/advocate/challenges/actions.js